import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FdFieldConfigs } from '../shared/fd-form-components/fd-form-components.module';
import { MatDialog } from '@angular/material/dialog';
import { AddOrEditReleaseOfUnwantedCnaeComponent } from './components/add-or-edit-release-of-unwanted-cnae/add-or-edit-release-of-unwanted-cnae.component';
import { MatTableDataSource } from '@angular/material/table';
import { ReleaseOfUnwantedCnaeModel, ReleaseOfUnwantedCnaeUpdateStatusModel, SearchReleaseOfUnwantedCnaeModel } from './models/releaseOfUnwantedCnae.models';
import { LoadingService } from '../shared/service/loading.service';
import { ReleaseOfUnwantedCnaeService } from './services/release-of-unwanted-cnae.service';
import { catchError, finalize } from 'rxjs/operators';
import { FdAlertComponent, ModalDefinitions } from '../shared/fd-form-components/fd-alert/fd-alert.component';
import { Messages } from '../shared/messages/messages';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from '../shared/service/error.service';
import { DialogService } from '../shared/service/dialog.service';

@Component({
  selector: 'app-release-of-unwanted-cnae',
  standalone: false,
  templateUrl: './release-of-unwanted-cnae.component.html',
  styleUrl: './release-of-unwanted-cnae.component.scss'
})
export class ReleaseOfUnwantedCnaeComponent implements OnInit {
  formGroup: UntypedFormGroup = new UntypedFormGroup({});
  fields: FdFieldConfigs = {};
  selectedInstitution: string = '';
  dataSource: MatTableDataSource<ReleaseOfUnwantedCnaeModel> = new MatTableDataSource<ReleaseOfUnwantedCnaeModel>();
  pageNumber = 0;
  size = 10;
  totalItens = 0;
  pageNumberFilter = 0;

  constructor(readonly formBuilder: UntypedFormBuilder,
    readonly loadingService: LoadingService,
    readonly releaseOfUnwantedCnaeService: ReleaseOfUnwantedCnaeService,
    readonly dialog: MatDialog,
    readonly errorService: ErrorService,
    readonly dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.startForms();
  }

  get formControls() {
    return this.formGroup.controls;
  }

  startForms(): void {

    this.formGroup = this.formBuilder.group({
      institution: ['', Validators.required],
      serviceContract: ['', Validators.required]
    });

    this.fields = {
      institution: {
        label: 'Nº Instituição',
        items: [],
        emptyOptionLabel: 'Selecione uma opção',
        controlName: 'institution',
        maskCharsReplace: /[. / -]/g,
        panelWidth: '320px',
        messages: {
          required: 'Informe uma instituição',
          invalid: 'Usuário inválido'
        }
      },
      serviceContract: {
        label: 'Service Contract',
        items: [],
        emptyOptionLabel: 'Selecione uma opção',
        controlName: 'serviceContract',
        maskCharsReplace: /[. / -]/g,
        panelWidth: '320px',
        messages: {
          required: 'Informe um service contract',
          invalid: 'Usuário inválido'
        }
      }
    };
  }

  changeSelectedInstitution(institution: string) {
    this.selectedInstitution = institution;
  }

  addReleaseOfUnwantedCnae() {
    this.openAddOrEditModal();
  }

  editReleaseOfUnwantedCnae(item: ReleaseOfUnwantedCnaeModel) {
    this.openAddOrEditModal(true, item);
  }

  openAddOrEditModal(editionModal?: boolean, releaseOfUnwantedCnae?: ReleaseOfUnwantedCnaeModel) {
    const dialogRef = this.dialog.open(AddOrEditReleaseOfUnwantedCnaeComponent, {
      width: '60%',
      height: '52%',
      ...(editionModal ? { data: { editionModal: true, releaseOfUnwantedCnae } } : {})
    });

    dialogRef.afterClosed().subscribe((updated: boolean) => {
      if (updated) {
        this.getAllReleaseOfUnwantedCnae(true);
      }
    });
  }

  // get hasWriteAccess() {
  //   return this.authService.isUserInRoles([AdminRolesEnum.CONFIGURATION_WRITE])
  // }

  changePage(event: any) {
    this.size = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.getAllReleaseOfUnwantedCnae(true);
  }

  updateStatus(payload: ReleaseOfUnwantedCnaeUpdateStatusModel) {//TODO - VALIDAR ORDEM DAS DATAS
    this.loadingService.show();

    this.releaseOfUnwantedCnaeService.updateStatus(payload)
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(() => {
        this.dialogService.openDialog(Messages.EDIT_SAVE_SUCCESS, () => this.getAllReleaseOfUnwantedCnae(true));
      }, (err: HttpErrorResponse) => this.errorService.handleXHRError(err, Messages.EDIT_SAVE_ERROR));
  }

  getAllReleaseOfUnwantedCnae(searchWithPageNumber: boolean = false) {
    if (!this.formGroup.valid) {
      return;
    }
    this.loadingService.show();

    this.pageNumberFilter = searchWithPageNumber ? this.pageNumber : 0;

    const filtro = new SearchReleaseOfUnwantedCnaeModel();
    filtro.size = this.size.toString();
    filtro.pageNumber = this.pageNumberFilter.toString();
    filtro.institution = this.formControls.institution.value;
    filtro.serviceContract = this.formControls.serviceContract.value;

    this.releaseOfUnwantedCnaeService.getAllPageable(filtro)
      .pipe(
        finalize(() => this.loadingService.hide()),
        catchError(error => {
          console.error('Erro ao buscar liberações de CNAE indesejadas:', error);
          this.dialog.open(FdAlertComponent, {
            disableClose: true,
            width: ModalDefinitions.DEFAULT_MODAL_WIDTH,
            data: Messages.SEARCH_ERROR
          });
          return of({ response: [], totalItens: 0, page: 0, size: 10 });
        })
      )
      .subscribe({
        next: (pageable) => {
          if (pageable?.response) {
            this.dataSource.data = Array.isArray(pageable.response) ? pageable.response : [];
            this.totalItens = pageable.totalItens || 0;
            this.pageNumber = pageable.page || 0;
            this.size = pageable.size || 10;
          }
        },
        error: (err) => {
          console.error('Erro no subscribe:', err);
          this.dataSource.data = [];
          this.totalItens = 0;
        }
      });
  }
}
